import { readSessionStoredValue, removeSessionStoredValue, writeSessionStoredValue } from './storage';

const workspaceProjectRouteKey = 'agentteams-workspace-project-routes';

type WorkspaceProjectRouteMap = Record<string, string>;

const parseRouteMap = (raw: string | null): WorkspaceProjectRouteMap => {
  if (!raw) return {};

  try {
    const parsed = JSON.parse(raw) as Record<string, unknown>;
    return Object.fromEntries(
      Object.entries(parsed).filter(
        (entry): entry is [string, string] => typeof entry[0] === 'string' && typeof entry[1] === 'string',
      ),
    );
  } catch {
    return {};
  }
};

const getRouteMap = (): WorkspaceProjectRouteMap => {
  // 저장소 차단 환경에서는 기억 기능 없이 빈 맵으로 동작한다 (WEB-R).
  return parseRouteMap(readSessionStoredValue(workspaceProjectRouteKey));
};

const saveRouteMap = (map: WorkspaceProjectRouteMap) => {
  writeSessionStoredValue(workspaceProjectRouteKey, JSON.stringify(map));
};

export const getWorkspaceProjectRoute = (projectId: string): string | null => {
  if (!projectId) return null;
  const route = getRouteMap()[projectId];
  return typeof route === 'string' && route.length > 0 ? route : null;
};

export const saveWorkspaceProjectRoute = (projectId: string, route: string) => {
  if (!projectId || route.length === 0) return;
  const map = getRouteMap();
  map[projectId] = route;
  saveRouteMap(map);
};

export const clearWorkspaceProjectRoutes = () => {
  removeSessionStoredValue(workspaceProjectRouteKey);
};
